import type {Area, MediaSize, Point} from 'react-easy-crop';

export function calculateMinZoom(
  mediaSize: MediaSize,
  cropArea: {width: number; height: number}
) {
  let theZoom = cropArea.width / mediaSize.width;
  if (mediaSize.naturalHeight > mediaSize.naturalWidth) {
    theZoom = cropArea.height / mediaSize.height;
  }
  return theZoom;
}

export function clampCrop(
  crop: Point,
  croppedArea: Area,
  mediaSize: MediaSize,
  cropArea: {width: number; height: number}
): Point {
  if (croppedArea.height >= 100) {
    let max =
      (cropArea.width / (mediaSize.naturalWidth * croppedArea.width)) *
      ((mediaSize.naturalWidth * (100 - croppedArea.width)) / 2);
    max = Math.max(0, max);
    const min = -1 * max;
    // restrict value with min max
    const x = Math.min(Math.max(min, crop.x), max);
    return {x, y: 0};
  }
  return crop;
}

export function clampCroppedAreaPixels(
  croppedAreaPixels: Area,
  mediaSize: MediaSize
): Area {
  return {
    width: Math.min(croppedAreaPixels.width, mediaSize.naturalWidth),
    height: Math.min(croppedAreaPixels.height, mediaSize.naturalHeight),
    x: Math.max(croppedAreaPixels.x, 0),
    y: Math.max(croppedAreaPixels.y, 0),
  };
}
